module.exports = __webpack_public_path__ + "img/1000.1f710996.gif";